// removed by extract-text-webpack-plugin
module.exports = {"Text":"Text__Text___hOWmZ","isRight":"Text__isRight___1Off0","isCenter":"Text__isCenter___1xA12","isLight":"Text__isLight___2Rkui","isAfterInput":"Text__isAfterInput___xFSJG","isSmall":"Text__isSmall___3P53u","isMiddle":"Text__isMiddle___2lAgV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Text/Text.scss
// module id = 610
// module chunks = 0